import { Grid, MenuItem, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import AlertDialog from "../../components/AlertDialog";
import FormikInput from "../../components/Form/FormikInput";
import FormikSelect from "../../components/Form/FormikSelect";
import FormikSwitch from "../../components/Form/FormikSwitch";

import Form from "../../components/Templates/Form";
import useDirectoryContainer from "../../containers/Directories/useDirectoryContainer";
import { directoryCategories } from "../../utils/constants";
import FormikMap from "../../components/Map";
import Info from "../../components/Info";
import ImageList from "../../components/ImageList";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { directoryCategoriesAr } from "../../utils/translations";
import { translator } from "../../utils/translations/translator";

const EditDirectory = () => {
  const { directoryId } = useParams();
  const {
    pageLoading,
    formik,
    loading,
    center,
    handleMarker,
    handleSearch,
    setCenter,
    zoom,
    setZoom,

    handleFile,

    images,
    openDeleteImage,
    setOpenDeleteImage,

    logo,
    handleLogo,

    handleOpenDeleteImage,
    handleDeleteImage,
    handleOpenDeleteLogo,
  } = useDirectoryContainer(directoryId, true);
  const { general, pages } = useContent();
  const { directories } = pages;
  const { isRTL } = useRTL();

  return (
    <Form
      title={directories.title}
      pageLoading={pageLoading}
      formik={formik}
      submitLoading={loading}
      id={directoryId}
      width="75%"
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormikInput formik={formik} name="name" label={directories.nameEn} />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            name="nameAr"
            label={directories.nameAr}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikSelect
            formik={formik}
            name="category"
            label={directories.category}
          >
            {directoryCategories.map((category: any) => (
              <MenuItem key={category.value} value={category.value}>
                {isRTL
                  ? translator(category.label, directoryCategoriesAr)
                  : category.label}
              </MenuItem>
            ))}
          </FormikSelect>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            name="address"
            label={directories.address}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            name="openingHours"
            label={directories.openingHoursEn}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            name="openingHoursAr"
            label={directories.openingHoursAr}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            name="partnerCode"
            label={directories.partnerCode}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikSwitch
            formik={formik}
            name="comingSoon"
            label={directories.comingSoon}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikSwitch
            formik={formik}
            name="status"
            label={directories.status}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormikSwitch
            formik={formik}
            name="reservable"
            label={directories.reservable}
          />
        </Grid>

        <Grid item xs={12}>
          <FormikInput formik={formik} name="meta" label={directories.metaEn} />
        </Grid>

        <Grid item xs={12}>
          <FormikInput
            formik={formik}
            name="metaAr"
            label={directories.metaAr}
          />
        </Grid>

        <Grid item xs={12}>
          <FormikInput
            formik={formik}
            name="website"
            label={directories.website}
          />
        </Grid>

        <Grid item xs={12}>
          <FormikInput formik={formik} name="phone" label={directories.phone} />
        </Grid>

        <Grid item xs={12}>
          <FormikMap
            center={center}
            setCenter={setCenter}
            markers={[
              {
                pos: {
                  lat: formik.values.latitude,
                  lng: formik.values.longitude,
                },
              },
            ]}
            handleMarker={(e: any) => handleMarker(e)}
            handleSearch={handleSearch}
            zoom={zoom}
            setZoom={setZoom}
            sx={{ height: "400px" }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            type="number"
            name="latitude"
            label={directories.lat}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            type="number"
            name="longitude"
            label={directories.lng}
          />
        </Grid>

        <Grid item xs={12}>
          <FormikInput formik={formik} name="POI" label={directories.poi} />
        </Grid>

        <Grid item xs={12}>
          <Info title={directories.images} />
          <ImageList images={images} handleAction={handleOpenDeleteImage} />

          <Button variant="contained" component="label" sx={{ my: 1 }}>
            {directories.chooseFile}
            <input
              hidden
              accept="image/*"
              multiple
              type="file"
              key={images}
              onChange={handleFile}
            />
          </Button>
        </Grid>

        <Grid item xs={12}>
          <Info title={directories.logo} />
          <ImageList images={logo} handleAction={handleOpenDeleteLogo} />

          <Button variant="contained" component="label" sx={{ my: 1 }}>
            {directories.chooseFile}
            <input
              hidden
              accept="image/*"
              type="file"
              key={logo}
              onChange={handleLogo}
            />
          </Button>
        </Grid>
      </Grid>

      <AlertDialog
        open={openDeleteImage}
        handleClose={() => setOpenDeleteImage(false)}
        onAgree={handleDeleteImage}
        loading={loading}
        agreeText={general.delete}
        disagreeText={general.cancel}
        title={directories.sureDeleteImg}
      />
    </Form>
  );
};

export default EditDirectory;
